import { IdcardOutlined, MailOutlined, SettingOutlined } from "@ant-design/icons";
import { HiOutlineLibrary } from "react-icons/hi";
import {
  Grid,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import MainCard from "components/MainCard";
import CircularIcon from "@ant-design/icons/QrcodeOutlined";
import FeeIcon from "@ant-design/icons/WalletOutlined";
import { useLocation, useNavigate, useParams } from "react-router-dom";

const LibraryTabs = () => {
  const navigateTo = useNavigate();
  const { libraryID } = useParams();
  const { pathname } = useLocation();
  const selectedIndex = (() => {
    if (pathname.includes("/circulation")) return 2;
    if (pathname.includes("/fine")) return 3;
    if (pathname.includes("/holiday")) return 4;
    if (pathname.includes("/email")) return 5;
    if (pathname.includes("/reminder")) return 6;
    if (pathname.includes("/membercard")) return 7;
    return 1;
  })();

  const handleListItemClick = (_index: number, route: string) => {
    navigateTo(route);
  };

  return (
    <>
      <MainCard>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <List
              component="nav"
              sx={{
                p: 0,
                "& .MuiListItemIcon-root": {
                  minWidth: 32,
                  color: "grey.500",
                },
              }}
            >
              <ListItemButton
                selected={selectedIndex === 1}
                onClick={() =>
                  handleListItemClick(
                    1,
                    `/admin/library/edit/${libraryID}/general`
                  )
                }
              >
                <ListItemIcon>
                  <HiOutlineLibrary />
                </ListItemIcon>
                <ListItemText primary="General Settings" />
              </ListItemButton>

              <ListItemButton
                selected={selectedIndex === 2}
                onClick={() =>
                  handleListItemClick(
                    2,
                    `/admin/library/edit/${libraryID}/circulation`
                  )
                }
              >
                <ListItemIcon>
                  <CircularIcon />
                </ListItemIcon>
                <ListItemText primary="Circulation Settings" />
              </ListItemButton>

              <ListItemButton
                selected={selectedIndex === 3}
                onClick={() =>
                  handleListItemClick(
                    3,
                    `/admin/library/edit/${libraryID}/fine`
                  )
                }
              >
                <ListItemIcon>
                  <FeeIcon />
                </ListItemIcon>
                <ListItemText primary="Fine Settings" />
              </ListItemButton>

              <ListItemButton
                selected={selectedIndex === 4}
                onClick={() =>
                  handleListItemClick(
                    4,
                    `/admin/library/edit/${libraryID}/holiday`
                  )
                }
              >
                <ListItemIcon>
                  <SettingOutlined />
                </ListItemIcon>
                <ListItemText primary="Holiday Settings" />
              </ListItemButton>
              <ListItemButton
                selected={selectedIndex === 5}
                onClick={() =>
                  handleListItemClick(
                    5,
                    `/admin/library/edit/${libraryID}/email`
                  )
                }
              >
                <ListItemIcon>
                  <MailOutlined />
                </ListItemIcon>
                <ListItemText primary="Email Settings" />
              </ListItemButton>
              <ListItemButton
                selected={selectedIndex === 6}
                onClick={() =>
                  handleListItemClick(
                    6,
                    `/admin/library/edit/${libraryID}/reminder`
                  )
                }
              >
                <ListItemIcon>
                  <MailOutlined />
                </ListItemIcon>
                <ListItemText primary="Reminder Settings" />
              </ListItemButton>

              <ListItemButton
                selected={selectedIndex === 7}
                onClick={() =>
                  handleListItemClick(
                    7,
                    `/admin/library/edit/${libraryID}/membercard`
                  )
                }
              >
                <ListItemIcon>
                  <IdcardOutlined />
                </ListItemIcon>
                <ListItemText primary="Member Card Settings" />
              </ListItemButton>
            </List>
          </Grid>
        </Grid>
      </MainCard>
    </>
  );
};

export default LibraryTabs;
